var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCacheWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 95,
    height: 19,
    viewBox: "0 0 95 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_0_169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 9.48609C0 3.8263 4.3395 0 10.3188 0C15.3981 0 19.3939 2.90829 19.9764 7.19233L14.7921 7.72847C14.3697 5.7913 12.5699 4.38773 10.4788 4.38773C7.5692 4.38773 5.5831 6.42859 5.5831 9.48862C5.60934 12.5486 7.59281 14.5895 10.45 14.5895C12.5148 14.5895 14.367 13.2138 14.8157 11.2993L20 11.8861C19.5251 16.1195 15.5031 19 10.3161 19C4.3395 19 0 15.1484 0 9.48609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19 19L24.9289 0H33.0972L39 19H33.2827L32.3865 16.1079H25.6135L24.7173 19H19ZM26.7215 12.1289H31.3073L29.1463 4.75263H28.8824L26.7215 12.1289Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M61 19V0H66.3777V7.58947H72.6223V0H78V19H72.6223V11.5763H66.3777V19H61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M80 19V0H94.7322V4.40526H85.4543V7.58947H94.2231V11.2237H85.4543V14.5947H95V19H80Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M53 4.47455C53 3.80078 53.291 3.2191 53.8788 2.73194C54.4636 2.24479 55.1591 2 55.968 2C56.7769 2 57.5335 2.24479 58.1212 2.73194C58.7061 3.2191 59 3.80078 59 4.47455C59 5.18226 58.7061 5.77848 58.1212 6.26806C57.5364 6.75521 56.8177 7 55.968 7C55.1183 7 54.4607 6.75521 53.8788 6.26806C53.291 5.7809 53 5.18226 53 4.47455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49 19C43.4859 19 39 14.7384 39 9.5C39 4.26159 43.4859 0 49 0V5.01825C46.3974 5.01825 44.2824 7.0301 44.2824 9.5C44.2824 11.9699 46.4001 13.9818 49 13.9818C51.5999 13.9818 53.7176 11.9724 53.7176 9.5H59C59 14.7384 54.5141 19 49 19Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCacheWordmark);
export default __webpack_public_path__ + "static/media/cache-wordmark.694ed2e70c75cca1ca89f430335991b6.svg";
export { ForwardRef as ReactComponent };